import api from "./api";

export const listMembers = () => api.get("/members");

export const inviteMember = (email, role = "MEMBER") =>
  api.post("/members/invite", { email, role });

export const updateMemberRole = (userId, role) =>
  api.patch(`/members/${userId}/role`, { role });

export const removeMember = (userId) =>
  api.delete(`/members/${userId}`);

export const acceptInvite = (token) =>
  api.get(`/members/accept/${token}`);

export const updateProfessionalProfile = (userId, { name, email, specialty, bio }) =>
  api.patch(`/members/${userId}/profile`, { name, email, specialty, bio });

export const updateProfessionalHours = (userId, businessHours) =>
  api.patch(`/members/${userId}/hours`, { businessHours });

export const createProfessional = (data) =>
  api.post("/members/professionals", data);

export const updateProfessionalServices = (userId, serviceIds) =>
  api.put(`/members/${userId}/services`, { serviceIds });
